import { render, staticRenderFns } from "./IntTrunks.vue?vue&type=template&id=4335eb57&"
import script from "./IntTrunks.vue?vue&type=script&lang=js&"
export * from "./IntTrunks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports